import { WEB_SERVICES } from "../../../bitSagas/webServices";
import { WEBSERVICE_ERRORS } from '../../errorCatalog';

export const getHandledErrors = (errorToPrint) => {
  const handledErrors = {
    BUSINESS_ERRORS: {
      INCORRECT_PARAMS: errorToPrint.INCORRECT_PARAMS,
      WITHOUT_COVERAGE: errorToPrint.WITHOUT_COVERAGE,
      FUSION_MANDATORY: errorToPrint.FUSION_MANDATORY,
      BLOCKED_USER: errorToPrint.BLOCKED_USER,
      MAX_R2R_REACHED: errorToPrint.MAX_R2R_REACHED,
      INCOMPATIBLE_CLIENT_PRODUCTS: errorToPrint.DEFAULT_ERROR,
      GO_LOGIN: errorToPrint.GO_LOGIN,
      CLIENT_ADVICE: errorToPrint.CLIENT_ADVICE,
      BUY_ALREADY_DONE: errorToPrint.BUY_ALREADY_DONE,
      SPEED_UNAVAILABLE: errorToPrint.SPEED_UNAVAILABLE,
      PROMOTION_NOT_APPLIED: errorToPrint.PROMOTION_NOT_APPLIED,
    },
    WEB_SERVICES_RULES: {
      [WEB_SERVICES.INIT_CQ]: {
        [WEBSERVICE_ERRORS.INCOMPATIBLE_PRODUCT]: errorToPrint.INCOMPATIBLE_PRODUCT,
        [WEBSERVICE_ERRORS.PRODUCT_WITHOUT_AVAILABLE_ACTIONS]: errorToPrint.INCOMPATIBLE_PRODUCT,
        [WEBSERVICE_ERRORS.INCORRECT_PRODUCT_OR_CQI]: errorToPrint.INCOMPATIBLE_PRODUCT,
        [WEBSERVICE_ERRORS.CUSTOMER_QUOTE_IN_PROGRESS]: errorToPrint.CUSTOMER_ORDER_IN_PROGRESS,
        [WEBSERVICE_ERRORS.CUSTOMER_ORDER_IN_PROGRESS]: errorToPrint.CUSTOMER_ORDER_IN_PROGRESS,
        [WEBSERVICE_ERRORS.CUSTOMER_QUOTE_NOT_CANCELABLE]: errorToPrint.CUSTOMER_ORDER_IN_PROGRESS,
        [WEBSERVICE_ERRORS.MIMOVISTAR_CUSTOMER_ORDER_IN_PROGRESSS]: errorToPrint.CUSTOMER_ORDER_IN_PROGRESS,
        [WEBSERVICE_ERRORS.INCORRECT_PRODUCT_OFFERING_STATE]: errorToPrint.INCORRECT_PRODUCT_OFFERING_STATE,
        [WEBSERVICE_ERRORS.PRODUCT_REGISTERED]: errorToPrint.PRODUCT_REGISTERED,
      },
      [WEB_SERVICES.INIT_CQ_TV]: {
        [WEBSERVICE_ERRORS.INCORRECT_PRODUCT_OR_CQI]: errorToPrint.INCOMPATIBLE_PRODUCT,
      },
      [WEB_SERVICES.UPDATE_CQ]: {
        [WEBSERVICE_ERRORS.CLIENT_RISK_DOC_NEEDED]: errorToPrint.CLIENT_RISK_DOC_NEEDED,
        [WEBSERVICE_ERRORS.CLIENT_RISK_VALIDATION]: errorToPrint.CLIENT_RISK_VALIDATION,
        [WEBSERVICE_ERRORS.MAX_R2R_REACHED]: errorToPrint.MAX_R2R_REACHED,
        [WEBSERVICE_ERRORS.CLIENT_WITH_DEBT]: errorToPrint.CLIENT_WITH_DEBT,
        [WEBSERVICE_ERRORS.CLIENT_RISK_ECONOMIC_DOC_NEEDED]: errorToPrint.CLIENT_WITH_DEBT,
        [WEBSERVICE_ERRORS.RISK_VALIDATION_UNAVAILABLE]: errorToPrint.RISK_VALIDATION_UNAVAILABLE,
        [WEBSERVICE_ERRORS.RISK_VALIDATION_TEMPORALLY_UNAVAILABLE]: errorToPrint.RISK_VALIDATION_UNAVAILABLE,
      },
      [WEB_SERVICES.GET_LEGAL_TERMS]: {
        [WEBSERVICE_ERRORS.LOW_SENIORITY_R2R]: errorToPrint.LOW_SENIORITY_R2R,
      },
    },
    DEFAULT_ERROR: errorToPrint.DEFAULT_ERROR,
  };

  return handledErrors;
};
